import React from 'react';

const CardRow = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex justify-between items-center border-b border-[#E0E0E0] py-1 last:border-b-0">
      {children}
    </div>
  );
};

export default CardRow;
